import { TravelersState } from "stores/wizard/state/global/travelers";
import { InfantSeating } from "src/components/shared/TravelersField/InfantSeating";
import { TravelersFieldConfig } from "src/stores/wizard/config";

export const travelersStateOnConfig = (config: TravelersFieldConfig): TravelersState => {
  return {
    hotel: {
      rooms: [
        {
          adults: config.minBookableTravelers,
          children: [],
          infants: [],
        },
      ],
      infantSeating: InfantSeating.ON_LAP,
    },
    hotelPackage: {
      rooms: [
        {
          adults: config.minBookableTravelers,
          children: [],
          infants: [],
        },
      ],
      infantSeating: InfantSeating.ON_LAP,
    },
    nonHotel: {
      rooms: [
        {
          adults: config.minBookableTravelers,
          children: [],
          infants: [],
        },
      ],
      infantSeating: InfantSeating.ON_LAP,
    },
    cruise: {
      rooms: [
        {
          adults: config.minBookableTravelers,
          children: [],
          infants: [],
        },
      ],
      infantSeating: InfantSeating.ON_LAP,
    },
  };
};

export const travelersState: TravelersState = {
  hotel: {
    rooms: [
      {
        adults: 0,
        children: [],
        infants: [],
      },
    ],
    infantSeating: InfantSeating.ON_LAP,
  },
  hotelPackage: {
    rooms: [
      {
        adults: 0,
        children: [],
        infants: [],
      },
    ],
    infantSeating: InfantSeating.ON_LAP,
  },
  nonHotel: {
    rooms: [
      {
        adults: 0,
        children: [],
        infants: [],
      },
    ],
    infantSeating: InfantSeating.ON_LAP,
  },
  cruise: {
    rooms: [
      {
        adults: 0,
        children: [],
        infants: [],
      },
    ],
    infantSeating: InfantSeating.ON_LAP,
  },
};
